/* jshint esversion: 6 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';

import $ from '@/components/js/jquery-vendor';

import VueRx from 'vue-rx';

import ElementUI from 'element-ui';
import AFTableColumn from 'af-table-column';
import 'element-ui/lib/theme-chalk/index.css';
import * as math from 'mathjs'

Vue.config.productionTip = false;

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.min';
import '@/assets/css/aHub.css';
import '@/assets/css/layout.min.css';
import '@/assets/css/overallDesign.css';
// import '@/assets/css/athub-v3.css';
import store from './stores';

/*import VueMatomo from 'vue-matomo'
Vue.use(VueMatomo, {
  host: process.env.VUE_APP_MATOMO_SERVER,
  siteId: 3, // siteId值
  router: router,
  requireConsent: false,
  enableLinkTracking: true,
  trackInitialView: true,
  trackerFileName: 'matomo',
  debug: false,
  userId: undefined,
  preInitActions: []
});*/

import 'font-awesome/css/font-awesome.min.css';
Vue.use(VueRx);
Vue.use(ElementUI);
Vue.use(AFTableColumn);

Vue.prototype.$math = math;

import Permission from './mixins/permission'
Vue.mixin(Permission);

import { AthubPermission } from './directives'
Vue.directive('athub-permission', AthubPermission);

var app = new Vue({
  router,
  store,
  $,
  render: h => h(App),
}).$mount('#app');

export default app;
